import React  from "react";
import classes from "./FlexContainer.module.css"
const FlexContainer = (props)=>{
    
    return (
        <div className={classes.FlexContainer}> 
            {props.children}

        </div>
    )
}

export default FlexContainer; 